import {isRTL} from '../../../../../Localization';

const en = {
    save_btn_tooltip: 'Save (Ctrl+S)',
    save_btn_title: 'Save',
    comment_btn_title: 'Add a Comment  (Ctrl+K)',
    picture_btn_title: 'Picture  (Ctrl+P)',
    hyperlink_btn_title: 'Hyperlink  (Ctrl+Q)',
    hline_btn_title: 'Horizontal Line  (Ctrl+H)',
    enlarge_text_size: 'Increase font size',
    reduce_text_size: 'Decrease font size',
    increase_indent_btn_title: 'Increase Indent  (Ctrl+>)',
    decrease_indent_btn_title: 'Decrease Indent  (Ctrl+<)',
    bullets_btn_title: 'Bullets  (Alt+B)',
    numbering_btn_title: 'Numbering  (Alt+N)',
    align_r_btn_title: 'Align Right  (Ctrl+R)',
    align_c_btn_title: 'Center  (Ctrl+M)',
    align_l_btn_title: 'Align Left  (Ctrl+L)',
    undo_btn_title: 'Undo  (Ctrl+Z)',
    underline_btn_title: 'Underline  (Ctrl+U)',
    italic_btn_title: 'Italic  (Ctrl+I)',
    bold_btn_title: 'Bold  (Ctrl+B)',
    txt_color_btn_title: 'Set Text Color  (Ctrl+O)',
    img_dialog_title: 'Insert Image',
    edit_link_dialog_title: 'Edit link',
    add_link_dialog_title: 'Add link',
    link_dialog_link_label: 'Link',
    link_dialog_link_placeholder: 'Type or paste a link',
    link_dialog_text_label: 'Display text',
    link_dialog_text_placeholder: 'Enter text…',
    dialog_add_btn_label: 'Add',
    ok_label: 'Ok',
    unlink_label: 'Unlink',
    open_link: 'Open link',
    back_label: 'Back',
    image_upload_label: 'Upload image',
    image_alt_label: 'Description',
    confirm: 'Confirm',
    image_url: 'Image URL',
    file_label: 'File',
    emoji_btn_title: 'Add emoji',
    strikethrough_btn_title: 'Strikethrough',
    cut_btn_title: 'Cut (Ctrl+X)',
    copy_btn_title: 'Copy (Ctrl+C)',
    paste_btn_title: 'Paste (Ctrl+V)'
};

const he = {
    save_btn_tooltip: 'שמור (Ctrl+S)',
    save_btn_title: 'שמור',
    comment_btn_title: 'הוסף עדכון  (Ctrl+K)',
    picture_btn_title: 'תמונה  (Ctrl+P)',
    hyperlink_btn_title: 'היפר קישור  (Ctrl+Q)',
    hline_btn_title: 'קו הפרדה אופקי  (Ctrl+H)',
    reduce_text_size: 'הקטנת גופן',
    enlarge_text_size: 'הגדלת גופן',
    increase_indent_btn_title: 'הגדלת כניסה (Ctrl+>)',
    decrease_indent_btn_title: 'הקטנת כניסה (Ctrl+<)',
    bullets_btn_title: 'תבליטים  (Alt+B)',
    numbering_btn_title: 'מיספור  (Alt+N)',
    align_r_btn_title: 'ישר לימין  (Ctrl+R)',
    align_c_btn_title: 'מרכז  (Ctrl+M)',
    align_l_btn_title: 'ישר לשמאל  (Ctrl+L)',
    undo_btn_title: 'בטל  (Ctrl+Z)',
    underline_btn_title: 'קו תחתון  (Ctrl+U)',
    italic_btn_title: 'נטוי  (Ctrl+I)',
    bold_btn_title: 'מודגש  (Ctrl+B)',
    txt_color_btn_title: 'קבע צבע  (Ctrl+O)',

    img_dialog_title: 'הוספת תמונה',
    edit_link_dialog_title: 'הוספת קישור',
    add_link_dialog_title: 'הוספת קישור',
    link_dialog_link_label: 'קישור',
    link_dialog_link_placeholder: 'כתובת URL',
    link_dialog_text_label: 'טקסט',
    link_dialog_text_placeholder: 'רשמו שם להצגה',
    dialog_add_btn_label: 'הוספה',

    ok_label: 'אישור',
    unlink_label: 'Unlink',
    open_link: 'פתח קישור',
    back_label: 'חזרה',
    image_upload_label: 'העלאת תמונה',
    image_alt_label: 'תיאור',
    confirm: 'בחירת קובץ',
    image_url: 'נתיב התמונה',
    file_label: 'קוֹבֶץ',
    emoji_btn_title: 'הוספת אימוג׳י',
    strikethrough_btn_title: 'קו חוצה',
    cut_btn_title: 'גזירה (Ctrl+X)',
    copy_btn_title: 'העתקה (Ctrl+C)',
    paste_btn_title: 'הדבקה (Ctrl+V)'
};

export const texts = isRTL() ? he : en;
